import {FlexAlign, FlexGap, FlexJustify, StackVertical} from "@twigsby/frontend-framework";
import React from "react";

const AuthLoader = () => {
    return (
        <div className={'auth-loader'}>
            <StackVertical gap={FlexGap.Large} align={FlexAlign.Center} justify={FlexJustify.Center}>
                <div className={'auth-emblem-loader'} />
                <div className={'dot-pulse'}>
                    <div/>
                    <div/>
                    <div/>
                </div>
            </StackVertical>
        </div>
    )
}

export {AuthLoader}
